/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import Topbar from './Topbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import OverView from '../Overview'
import LikeCommentViewReport from './LikeCommentViewReport'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { fetchCourseModule, selectCompletedLessonCount, selectCourseModule, selectCourseModuleContent, selectLessonBySlugs, selectModuleBySlug } from '../../redux/courseModuleSlice'
import { selectAuthentication } from '../../redux/authenticationSlice'
import { selectCourseList } from '../../redux/courseListSlice'
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../../utilities/constants'
import VideoPlayer from './VideoPlayer'
import LockedLessons from './LockedLessons'
import useWindowSize from '../../hooks/useWindowSize'
import Walkthrough from '../Walkthrough/Walkthrough'
import { contentPlayerPageWalkthrough, contentPlayerPageWalkthroughMobile } from '../Walkthrough/WalkthroughData'
import { fetchWalkthroughData, postWalkthroughData, selectWalkthroughData } from '../../redux/walkthrough'
import DeskTopOverView from './DeskTopOverView'
import DesktopOtherSection from './DesktopOtherSection'
import QuizCompletionModal from './QuizCompletionModal'
import { setShowQuizModal } from '../../redux/lessonQuizSlice'
import WhatYouGetWithThisCourse from './WhatYouGetWithThisCourse'
import { fetchOnboardingUserDetails, fetchRazorpayId, fetchUUID, selectOnboardingUserDetails } from '../../redux/onboardingUserDetails'
import { RAZORPAY_KEY } from '../../config/api_config'
import useRazorpay from 'react-razorpay'
import { toast } from 'react-toastify'
import DesktopOnboardingOverview from './DesktopOnboardingOverview'
import StickyBar from './StickyBar'
import { selectUserSkillDetails } from '../../redux/skillSlice'

const LessonPage = ({ quizRef }) => {

    const Razorpay = useRazorpay();
    const [showOverview, setShowOverview] = useState(false)
    const [ lessonIndex, setLessonIndex ] = useState(0)
    const [ userGoal, setUserGoal ] = useState("")
    const [ showQuizCompletionModal, setShowQuizCompletionModal ] = useState(false)
    const [ showTimeLine, setShowTimeLine ] = useState(false)
    const [ currentModuleIndex, setCurrentModuleIndex ] = useState(-1)
    const { module_slug, lesson_slug } = useParams()
    const { width } = useWindowSize()
    
    const courseModule = useSelector(selectCourseModule)
    const courseModuleContent = useSelector(selectCourseModuleContent)
    const moduleDetails = useSelector((state) => selectModuleBySlug(state, module_slug))
    const lessonDetails = useSelector((state) => selectLessonBySlugs(state, module_slug, lesson_slug))
    const completedLessonCount = useSelector((state) => selectCompletedLessonCount(state, module_slug))
    const uid = useSelector(selectAuthentication)?.uid
    const courseList = useSelector(selectCourseList)
    const subject_name = courseList?.courseName
    const authentication = useSelector(selectAuthentication)
    const walkthroughStatus = useSelector(selectWalkthroughData)
    const onboardingUserDetails = useSelector(selectOnboardingUserDetails)
    const skillDetails = useSelector(selectUserSkillDetails)

    

    
    const { email } = authentication
    
    
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const scrollRef = useRef(null)
    const videoPlayerRef = useRef(null)

    const isOnBoarding= courseModule?.is_onboarding;
    const isFirstLessonCompleted = courseModule?.course_data?.[0]?.module_content?.[0]?.lesson_status === 'completed';
    const isSecondLessonCompleted = courseModule?.course_data?.[0]?.module_content?.[1]?.lesson_status === 'completed';
    const showOnboardingOverview =  isOnBoarding && (currentModuleIndex !==0 || (lessonIndex -1 !== 0 && lessonIndex - 1 !== 1));
    const [isModalLoading , setIsModalLoading] = useState(false) 




    useEffect(() => {
        if(showOnboardingOverview){
            dispatch(fetchOnboardingUserDetails({ uuid: uid }))
        }
    }, [showOnboardingOverview])
    useEffect(() => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE)
        dispatch(fetchWalkthroughData({ email }))
    }, [])

    console.log('moduleDetails' , moduleDetails, courseModuleContent)

    useEffect(() => {
        setLessonIndex(moduleDetails?.module_content?.findIndex((item) => item?.lesson_slug === lesson_slug) + 1)
    }, [moduleDetails, lesson_slug])

    useEffect(()=>{
        if (scrollRef.current){
            scrollRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }, [module_slug, lesson_slug])

    useEffect(() => {
        if (!showOverview && scrollRef.current){
            scrollRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }, [showOverview])

    useEffect(() => {
        const moduleIndex = courseModuleContent?.findIndex((item) => item?.module_slug === module_slug)
        const newArray = courseModuleContent?.slice(0, moduleIndex + 1)
        setCurrentModuleIndex(moduleIndex)
        const moduleQuizNotCompleted = newArray?.some((item) => item?.module_progress !== 100)
        dispatch(setShowQuizModal(moduleQuizNotCompleted))
    }, [module_slug])

    const handleCourseCrumb = () => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_COURSE_CRUMB_CLICKED)
        navigate(`/${encodeURIComponent(subject_name)}`)
    }

    const walkthroughHandler = (email) => {
        dispatch(postWalkthroughData({ email: email}))
    }

    const getOrderStatusSuccess = async (response) => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_ONBOARDING_COURSE_PURCHASE_SUCCESS)
        try{
            await dispatch(fetchCourseModule({ uid: uid, subject_name: subject_name })).unwrap();
            setIsModalLoading(false)
            window.location.reload();
        } catch (e) {
            console.error(e.message);
            toast.error("Something Went Wrong on Fetching Course Module ! Try Again", e);
            setIsModalLoading(false)
        }
    }

    const handleUnlock = async (e) => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_ONBOARDING_COURSE_PURCHASE_BUTTON_CLICKED)
        e.preventDefault();
        setIsModalLoading(true)
        const name = onboardingUserDetails?.name;
        const email = onboardingUserDetails?.email;
        const phone_number = onboardingUserDetails?.phone_number;
        const utm_medium = skillDetails?.utm_medium;
        const utm_source = skillDetails?.utm_source;
        try {
            const uuidResponse = await dispatch(
              fetchUUID({
                name,
                email,
                phone_number,
                skill_name: courseModule?.course_name,
                medium : utm_medium,
                source : utm_source,
              })
            ).unwrap();
           
            const razorpayOrderId = await dispatch(
              fetchRazorpayId({
                uid: uuidResponse?.uuid,
                amount: 399,
                product_name: 'Onboarding Course Purchase from Personalise',
              })
            ).unwrap();
          

            const options = {
              key: RAZORPAY_KEY,
              currency: "INR",
              name: name,
              description: `Personalise Course Purchased from Personalise`,
              image: "",
              order_id: razorpayOrderId?.razorpay_order_id,
              modal: {
                ondismiss: function () {
                },
              },
              handler: (res) => {
                getOrderStatusSuccess(res)
              },
              prefill: {
                name: name,
                email: email,
                contact: phone_number,
              },
              notes: {
                address: "Razorpay Corporate Office",
                olduid : uid,
                skill_name : courseModule?.course_name,
              },
              theme: {
                color: "#26CBA1",
              },
            };


            const rzp1 = new Razorpay(options);
            rzp1.on("payment.failed", function (response) {
                setIsModalLoading(false)
            //   getBundleOrderStatusFailed(response, uuidResponse?.uuid);
            });
            rzp1.open();
          } catch (e) {
            console.error(e.message);
            toast.error("Something Went Wrong on Razorpay Order ! Try Again", e);
          } finally {
            setIsModalLoading(false)
          }
    }

    const loader = () => {
        return (
            <div className='flex justify-center items-center'>
                <div className='animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500'></div>
            </div>
        )
    }

  
    return (
        <>
            {!showOverview ? (moduleDetails?.is_locked ? <LockedLessons/> : <div className='text-white max-w-[1440px] w-full mx-auto' ref={scrollRef}>
                <Topbar
                    name={"Lessons"}
                    showOverview={showOverview}
                    setShowOverview={setShowOverview}
                    lessonsCompleted={completedLessonCount}
                    lessonLength={moduleDetails?.module_content?.length}
                    subject_name={subject_name}
                />
                <div className='lg:flex'>
                    <div className={`lg:flex-1 ${!showOnboardingOverview && 'lg:h-screen'} lg:w-[93%] lg:overflow-y-scroll`}>
                        <div className='p-4 lg:px-6'>
                            <div className='mt-1 flex items-center'>
                                <p className='leading-[12px]'><span className='text-xs sm:text-xl mr-1.5 text-[#7FC241] cursor-pointer' onClick={handleCourseCrumb}>{ subject_name}</span>
                                <FontAwesomeIcon icon={faChevronRight} className='opacity-50 text-xs sm:text-lg'/>
                                <span className='text-xs sm:text-xl ml-1.5 cursor-pointer' onClick={() => {
                                    Mixpanel.track(constants.Mixpanel.LESSON_PAGE_LESSON_CRUMB_CLICKED)
                                    setShowOverview(!showOverview)
                                }}>{lessonDetails?.lesson_name}</span>
                                </p>
                            </div>
                            <p className='text-xl sm:hidden mt-3 opacity-50'>Lesson {lessonIndex}</p>
                            <h3 className='text-xl sm:hidden font-bold leading-6 mt-2'>{lessonDetails?.lesson_name}</h3>
                            <p className={`text-sm sm:hidden opacity-80 ${lessonDetails?.intro_text ? 'mt-3' : ''}`}>{lessonDetails?.intro_text}</p>
                        </div>
                        <div>
                            <div className='mb-3 cursor-pointer reactour-videoplayer lg:px-6'>
                                <VideoPlayer 
                                    lesson_slug={lesson_slug}
                                    videoPlayerRef={videoPlayerRef}
                                    showOnboardingOverview={showOnboardingOverview}
                                    handleUnlock={handleUnlock}
                                    isModalLoading={isModalLoading}
                                />
                            </div>
                            <LikeCommentViewReport
                                videoPlayerRef={videoPlayerRef}
                                showTimeLine={showTimeLine}
                                setShowTimeLine={setShowTimeLine}
                            />
                        </div>
                        {showOnboardingOverview ?
                        
                        <WhatYouGetWithThisCourse
                            lessonName={lessonDetails?.lesson_name}
                            moduleName={moduleDetails?.module_name}
                            courseModule={courseModule}
                            lessonIndex={lessonIndex}
                            completedLessons={Number(!!isFirstLessonCompleted) + Number(!!isSecondLessonCompleted)}
                            handleUnlock={handleUnlock}
                            isModalLoading={isModalLoading}
                        /> : <DesktopOtherSection
                            lessonName={lessonDetails?.lesson_name}
                            courseModule={courseModule}
                            videoId={lessonDetails?.video_url?.split("?")?.[1]?.split("=")?.[1]}
                            userGoal={userGoal}
                            setUserGoal={setUserGoal}
                            course_slug={subject_name}
                            lesson_slug={lesson_slug}
                            lesson_name={lessonDetails?.lesson_name}
                            module_slug={module_slug}
                            lessonId={lessonDetails?.lesson_id}
                            scrollRef={scrollRef}
                            lessonDetails={lessonDetails}
                            quizRef={quizRef}
                        />}
                    </div>
                    <div className='hidden lg:flex flex-col w-[30%]'>
                        {showOnboardingOverview ? 
                        <DesktopOnboardingOverview
                            courseModule={courseModule} 
                            lessonIndex={lessonIndex} 
                            completedLessons={Number(!!isFirstLessonCompleted) + Number(!!isSecondLessonCompleted)}
                            handleUnlock={handleUnlock}
                            isModalLoading={isModalLoading}
                        /> 
                        : <DeskTopOverView 
                            showOverview={showOverview}
                            setShowOverview={setShowOverview}
                            courseName={subject_name}
                            courseModule={courseModule}
                            lessonId={lessonDetails?.lesson_id}
                            module_slug={module_slug}
                            setShowQuizCompletionModal={setShowQuizCompletionModal}
                            currentModuleIndex={currentModuleIndex}
                            setShowTimeLine={setShowTimeLine}
                        />} 
                    </div>
                </div>
            </div>) : 
            <OverView
                showOverview={showOverview}
                setShowOverview={setShowOverview}
                courseName={subject_name}
                courseModule={courseModule}
                lessonId={lessonDetails?.lesson_id}
                setShowQuizCompletionModal={setShowQuizCompletionModal}
                module_slug={module_slug}
            />}
            {showQuizCompletionModal && <QuizCompletionModal
                isOpen={showQuizCompletionModal}
                setIsOpen={setShowQuizCompletionModal}
            />}
            {!walkthroughStatus?.walkthrough && <Walkthrough
                tourOpen={true}
                steps={ width >= 1024 ? contentPlayerPageWalkthrough : contentPlayerPageWalkthroughMobile }
                onCloseFunction={[() => walkthroughHandler(email)]}
            />}
            {/* {
               width <= 768 && showOnboardingOverview && <StickyBar handleUnlock={handleUnlock} />
            } */}
        
        </>
    )
}

export default LessonPage
